import { axios } from "utils";

import { ADMIN_POPUPS_URL as endpoint } from "consts";

import { Popup, PopupRequest, PopupResponse } from "models";

export const getAllPopups = async (): Promise<PopupResponse[]> => axios.get(`${endpoint}`);

export const updatePopup = async (data: PopupRequest[]) => axios.put(`${endpoint}`, { data });

export const getPopup = async ({ id }: { id: string }): Promise<Popup[]> => axios.get(`${endpoint}/${id}`);
